<!--
 * @Description: Jeson Create File
 * @Version: 1.0
 * @Autor: Jeson
 * @Date: 2022-01-12 20:29:53
 * @LastEditors: Jeson
 * @LastEditTime: 2022-01-20 09:13:30
-->
<template>
  <div class="list-div">
    <div
      v-for="goods in dataList"
      :key="goods.Id"
      class="item"
    >
      <!-- list 组件(普通活动样式，适用于宫格) -->
      <NewProductItem
        ref="NewProductItem"
        :product="goods"
      />
    </div>
  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'SearchPageItem',
  mixins: [BaseMixin],
  data() {
    return {
      dataList: [],
      searchData: {
        Offset: 0 // 偏移量
      },
      // 是否分页标记,后端返回
      IsHasNext: false,
      // 计时器(节流延时跳转，避免快速加载)
      timer: null
    }
  },
  created() {

  },
  mounted() {
    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
    this.loadData()
  },
  methods: {
    async loadData() {
      this.$hys.openLoading()
      const res = await this.getAction('/api_goods/GoodsSku/ListForCustomerV3', this.searchData)
      this.$hys.clearLoading()

      // 如果有商品定时器集合，则清除

      if (res.IsSuccess) {
        this.finished = true

        // 追加到本地数据集合中
        res.Data.GoodsList.forEach((item) => {
          this.dataList.push(item)
        })
        // 本地数据集合通过ID去重
        // this.dataList = this.dataList.filter(function(element, index, self) {
        //   return self.findIndex((el) => el.Id === element.Id) === index
        // })

        // 关闭加载层
        this.$hys.clearLoading()
        // 保存分页标记，由后端返回，第一次第一页，前端默认传递0 （偏移量）
        this.searchData.Offset = res.Data.Offset
        // 保存是否分页标记
        this.IsHasNext = res.Data.IsHasNext

        // 保存接口返回偏移量
        this.searchData.Offset = res.Data.Offset
        // 保存接口返回是否有下一页标记
        this.IsHasNext = res.Data.IsHasNext
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    /*
     * 监听页面滑动
     */
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 到达页面底部时
      if (scrollTop + clientHeight === scrollHeight && this.IsHasNext) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        // 开启加载层
        this.$hys.openLoading()
        // 延时请求
        this.timer = setTimeout(() => {
          // 获取list
          this.loadData()
        }, 1000)
      }
    }
  }
}
</script>
<style scoped lang="less">
.list-div {
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .item {
    margin: 4px 0;
    width: 240px;
  }
}

</style>

